<div class="ui basic segment" [class.loading]="true">
    <app-header title="payroll.xeroCallback.xeroSetup"></app-header>
    <p>{{ 'payroll.xeroCallback.pleaseWaitWhileTheXeroSetupFinalizes' | translate }}</p>
</div>
